/* eslint-disable no-unused-vars */

import { PiracyCommonEnumsProductTypeEnum } from '~/swagger/data-contracts';

export interface IAsset {
  assetId: number;
  assetName: string;
}

export const productTypeLabel: Record<PiracyCommonEnumsProductTypeEnum, string> = {
  [PiracyCommonEnumsProductTypeEnum.Webcomic]: 'Web Comics',
  [PiracyCommonEnumsProductTypeEnum.Webnovel]: 'Web Novel',
  [PiracyCommonEnumsProductTypeEnum.Game]: 'Game',
  [PiracyCommonEnumsProductTypeEnum.Adult]: 'Adult',
  [PiracyCommonEnumsProductTypeEnum.Sports]: 'Sports',
  [PiracyCommonEnumsProductTypeEnum.Publishing]: 'Publishing',
  [PiracyCommonEnumsProductTypeEnum.Music]: 'Music',
  [PiracyCommonEnumsProductTypeEnum.ELearning]: 'E-Learning',
  [PiracyCommonEnumsProductTypeEnum.Films]: 'Films & TV',
  [PiracyCommonEnumsProductTypeEnum.Animation]: 'Animation',
  [PiracyCommonEnumsProductTypeEnum.Software]: 'Software',
  [PiracyCommonEnumsProductTypeEnum.Video]: 'Video',
};

export const productList = Object.values(PiracyCommonEnumsProductTypeEnum).map((value) => ({
  value,
  label: productTypeLabel[value],
}));

export const enum RouteNameEnum {
  Performance = '/performance',
  PerformanceReports = '/performance-reports',
  AssetPortfolio = '/asset-portfolio',
  Enforcement = '/enforcement',
}

export enum PerformanceRouteNameEnum {
  Overview = 'overview',
  Reports = 'reports',
  SearchEngine = 'search-engine',
  SocialMediaVideo = 'social-media-video',
  ComplianceRate = 'compliance-rate',
  DomainProfileAnalysis = 'domain-profile-analysis',
}
